// extracted by mini-css-extract-plugin
export default {"tab":"MobileAppSelection__tab__zh4Op","hidden":"MobileAppSelection__hidden__srMtu"};